import { render, staticRenderFns } from "./KudosCard.vue?vue&type=template&id=620a1e64&"
import script from "./KudosCard.vue?vue&type=script&lang=js&"
export * from "./KudosCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports